import { AgentThread, ProjectIcon } from '@dreamai/types';

/**
 * Extract the project tag icon path from a thread's discussing_objects.
 * Returns the `/splicons/project-tags/{icon}.png` path, or the fallback
 * "other" icon if no tag has been assigned yet.
 *
 * Returns `null` for threads that are not projects.
 */
export function getProjectTagIconUrl(thread: AgentThread): string | null {
  const projectObj = thread.discussing_objects?.find(
    (d) => d.discussing_object === 'Project',
  );
  if (!projectObj) return null;

  const icon: ProjectIcon | undefined =
    projectObj.discussing_object_match?.projectIcon;

  return `/splicons/project-tags/${icon || 'other'}.png`;
}
